import { factory, stateOptions } from '../utils'

function getName({ firstName, lastName }) {
  return `${firstName} ${lastName}`
}

export default {
  auto: '*',
  // getCheck: 'email',
  // hasJoins: true,

  store: {
    getters: {
      userFactory: factory(() => ({
        email: null,
        password: null,
        firstName: null,
        lastName: null,
        country: null,
        role: 'USER',
      })),

      userOptions: stateOptions(getName),
    },
  },
}
